import '@babel/polyfill/noConflict';
import { isFudaoApp } from '@tencent/imutils/dist/esm/util_04_ua';
import { tdwReport } from '@tencent/imutils/dist/esm/util_26_tdw_report';
import { openAppPage } from '@tencent/imutils/dist/esm/util_15_app';
import { parseQueryString } from '@tencent/imutils/dist/esm/util_09_url';
import imlog, { LEVELS } from '@tencent/imlog';
import React from 'react';
import ReactDOM from 'react-dom';
import SHARE from './assets/images/shareBtnShadow.png';
import './assets/js/qqapi';
import App from './src/app';

ReactDOM.render(<App />, document.getElementById('react-body'));

function initAppShare() {
  if (!isFudaoApp() || !window.mqq) {
    return;
  }

  window.mqq.invoke('edu', 'setRightTitle', {
    enable: 1,
    imageIcon: SHARE,
    imageIconDefault: SHARE,
  });

  window.mqq.addEventListener('rightTitleClicked', () => {
    const { title, desc } = window.VISION.meta;
    window.mqq.invoke('edu', 'showShareSelectDlg', {
      title,
      summary: desc,
      url: window.location.href,
      // coverImageUrl: ,
    });
  });
}

function overrideOpen() {
  if (!isFudaoApp()) {
    return;
  }
  // const originalOpen = window.open;
  window.open = function(url) {
    try {
      openAppPage('webview', { url: encodeURIComponent(url) });
    } catch (e) {
      window.location.href = url;
    }
  };
}

function init() {
  if (!window.__tdw_report_inited) {
    // 罗盘
    const url = window.location.href;
    const reportData = { page: `[vision]${window.VISION.meta.actKey}` };

    if (url.indexOf('zjs') > -1) {
      const { s } = parseQueryString(url);
      reportData.ext = s || 0;
    }

    tdwReport.init(reportData);
    window.__tdw_report_inited = true;
  }

  // badjs 上报
  if (window.BJ_REPORT) {
    window.BJ_REPORT.init({ id: 1412 });
  }

  if (!window.imlogger) {
    const logger = imlog.createReportor('main');
    logger.config({
      project: 'materials-fudao',
      bizId: 'k12',
      logger: {
        keep: 7, // 用户日志在本地储存7天
        autoUpload: LEVELS.info,
      },
    });
    window.imlogger = logger;
  }

  // APP 内禁用新 Tab 中打开
  overrideOpen();

  initAppShare();
}

window.addEventListener('load', init);
